import { render, staticRenderFns } from "./Login5.vue?vue&type=template&id=edc6b0d2&"
import script from "./Login5.vue?vue&type=script&lang=js&"
export * from "./Login5.vue?vue&type=script&lang=js&"
import style0 from "./Login5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports